import {BadgeColorScheme} from "peggirkit/dist/components/Badge/BadgeElements/BadgeStyles";

export const flagStyleMap: Record<string, { style: BadgeColorScheme }> = {
    // Taste warnings
    alcoholic: {style: "warning"},
    hot: {style: "warning"},
    spicy: {style: "warning"},
    mild: {style: "warning"},

    // Allergens
    egg: {style: "danger"},
    wheat: {style: "danger"},
    lupine: {style: "danger"},
    lactose: {style: "danger"},
    mustard: {style: "danger"},
    nuts: {style: "danger"},
    peanut: {style: "danger"},
    shellfish: {style: "danger"},
    celery: {style: "danger"},
    sesame: {style: "danger"},
    soya: {style: "danger"},
    fish: {style: "danger"},
    mollusc: {style: "danger"},
    sulphite: {style: "danger"},

    // Dietary preference
    vegetarian: {style: "success"},
    vegan: {style: "success"},
    halal: {style: "success"},
};